import React from 'react';
import PropTypes from 'prop-types';

import {Typography} from 'views/components';
import {MarkdownViewer, Translate} from 'views/module';

import CardPaper from './CardPaper';

const AdditionalConsiderationsCard = (props) => {
  const {requirements} = props;

  const hasMeaningfulText = (value) => {
    if (typeof value !== 'string') return false;

    // remove normal whitespace + zero-width characters
    const cleaned = value
        .replace(/[\s\u200B-\u200D\uFEFF]/g, '') // spaces + zero-width
        .trim();

    return cleaned.length > 0;
  };
  const blob = requirements.additionalConsiderations?.blob;
  if (!hasMeaningfulText(blob)) return null;

  return (
    <CardPaper>
      <Typography variant="body2" sx={{fontWeight: 800, mb: 1}}>
        <Translate expression='jobDetail.AdditionalConsiderations' />
      </Typography>

      <MarkdownViewer value={blob} />
    </CardPaper>
  );
};

AdditionalConsiderationsCard.propTypes = {
  requirements: PropTypes.object.isRequired,
};

export default AdditionalConsiderationsCard;
